import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoIsThisFor() {
  const forList = ["Heirs who live out-of-state and can't babysit a vacant property.", 'Executors who feel overwhelmed by the legal and financial "Paperwork Ghost."', 'Families facing a "Reverse Mortgage" ticking time bomb.', 'Anyone who needs to settle an estate without getting low-balled by predatory investors.'];
  const notForList = ['Professional house flippers or wholesalers looking for "deals."', 'People who have already finished probate and have a clear title.', 'Anyone unwilling to take 30 minutes to read and execute the instructions.'];
  return <section className="bg-navy py-24 px-4 border-y border-copper/20" data-id="element-222">
      <div className="max-w-6xl mx-auto" data-id="element-223">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-24" data-id="element-224">
          {/* FOR YOU */}
          <FadeIn direction="right" data-id="element-225">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-cream mb-8 pb-4 border-b border-copper/30" data-id="element-226">
              This Is <span className="text-copper italic" data-id="element-227">For You</span> If...
            </h2>
            <ul className="space-y-6" data-id="element-228">
              {forList.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-229">
                  <div className="flex-shrink-0 mt-1" data-id="element-230">
                    <CheckIcon className="w-6 h-6 text-emerald-500" data-id="element-231" />
                  </div>
                  <p className="text-lg font-body text-white leading-relaxed" data-id="element-232">
                    {item}
                  </p>
                </li>)}
            </ul>
          </FadeIn>

          {/* NOT FOR YOU */}
          <FadeIn direction="left" delay={0.2} data-id="element-233">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-cream mb-8 pb-4 border-b border-cream/20" data-id="element-234">
              This Is NOT For You If...
            </h2>
            <ul className="space-y-6" data-id="element-235">
              {notForList.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-236">
                  <div className="flex-shrink-0 mt-1" data-id="element-237">
                    <XIcon className="w-6 h-6 text-red-400" data-id="element-238" />
                  </div>
                  <p className="text-lg font-body text-cream leading-relaxed" data-id="element-239">
                    {item}
                  </p>
                </li>)}
            </ul>
          </FadeIn>
        </div>
      </div>
    </section>;
}